<template>
  <div class="index_con" :class="theme ? 'theme-background-bg' : ''">
    <!-- <a href= "../integratedLogin/index.vue">跳转</a> -->
    <div style="background-color: #fff; padding-bottom: 63px">
      <div class="index_banner_box">
        <carousel :imgList="banner" @bannerdetail="bannerdetail"></carousel>
      </div>
      <search></search>
      <div v-if="homePageData[0]" class="recommend-module">
        <indexTitle :title="homePageData[0].moduleName"></indexTitle>
        <bookSuggest :id="homePageData[0].id" :id2="homePageData[1].id"></bookSuggest>
        <div v-if="floatingStatic" class="floating-icons">
          <img :src="floatingData.imagePath" alt="" @click="bannerdetail(floatingData.chainedAddress)" />
          <i @click="floatingStatic = false" class="el-icon-close"></i>
        </div>
      </div>
      <!--特色资源-->
      <div style="margin-top: 87px" v-if="homePageData[2]">
        <characteristic :homePageData="homePageData[2]" :homePageData2="homePageData[3]"></characteristic>
      </div>
    </div>
    <div style="background-color: #e7f3ff; overflow: hidden" v-if="homePageData[4]">
      <div style="margin-top: 45px">
        <indexTitle :title="homePageData[4].moduleName"></indexTitle>
        <newBooks :id="homePageData[4].id" v-if="homePageData[4]"></newBooks>
      </div>
      <div style="margin-bottom: 68px" v-if="homePageData[5]">
        <fine :homePageData="homePageData[5]" :homePageData2="homePageData[6]"></fine>
      </div>
    </div>
    <!--名师讲坛-->
    <div style="margin-top: 73px" v-if="homePageData[7]">
      <tribune :homePageData="homePageData[7]" :homePageData2="homePageData[8]" :homePageData3="homePageData[10]">
      </tribune>
    </div>
    <div style="margin-top: 45px" v-if="homePageData[9]">
      <indexTitle :title="homePageData[9].moduleName"></indexTitle>
      <like :id="homePageData[9].id"></like>
    </div>
    <!-- <integralBox class="topLeft"></integralBox> -->
  </div>
</template>
<script>
import { getHomePageList } from "@/api/index/index.js";
import integralBox from "@/components/integralBox.vue";
import carousel from "@/components/carousel.vue";
import search from "./components/search";
import indexTitle from "./components/indexTitle";
import bookSuggest from "@/views/index/components/bookSuggest";
import fine from "./components/fine";
import characteristic from "./components/characteristic";
import newBooks from "./components/newBooks";
import tribune from "./components/tribune";
import like from "./components/like";
import {
  bannerList,
  goodsList,
  goodBookList,
  getGuessFavouriteNoLogin,
  getGuessFavouriteForLogin,
  homePageselHotBookList,
  selSubjectList,
  selAuthorList,
  selDeptList,
  getConfigKey,
  getBannerList,
} from "@/api/index/index.js";
import "swiper/css/swiper.css"; //引入swiper样式
import Swiper from "swiper"; //引入swiper
import integratedLogin from "../IntegratedLogin/index.vue"
import { removeBrowserToken } from "@/utils/auth.js"
export default {
  components: {
    integralBox,
    carousel,
    search,
    indexTitle,
    bookSuggest,
    characteristic,
    fine,
    newBooks,
    tribune,
    like,
    // integratedLogin,
  },
  data() {
    return {
      theme: false, //首页置灰
      defaultImg: require("@/assets/images/default-avatar.jpg"),
      defaultDeptAvatar: require("@/assets/images/inst_default_avatar.png"),
      banner: [], //banner
      goods: [], //新书速递
      goodBook: [], //好书推荐
      GuessFavourite: [], //猜你喜欢
      homePageselHotBook: [], //热门图书
      selSubject: [], //特色专题
      selAuthor: [], //作者
      selDept: [], //合作机构
      goodsType: 0, //热门图书分类
      goodsTypeList: [
        {
          value: "material",
          lable: "教材类",
        },
        {
          value: "reference",
          lable: "教辅类",
        },
        {
          value: "learning",
          lable: "学术类",
        },
        {
          value: "paper",
          lable: "试卷类",
        },
        {
          value: "other",
          lable: "其他类",
        },
        {
          value: "train",
          lable: "培训类",
        },
      ],
      hoverTimer: undefined, //hover延时
      setinter: undefined,
      homePageData: {},
      floatingData: [],
      floatingStatic: false,
    };
  },
  created() {
    this.$store.commit("SET_ISLAYOUT", true);
    removeBrowserToken()
    this.getConfig();
    getHomePageList().then((res) => {
      this.homePageData = res.data;

      // getCatalogList({featuredId:this.homePageData[1].id}).then(res=>{
      //   console.log(res);
      // })
    });
    getBannerList({
      pageNum: 1,
      pageSize: 100,
      addressType: "floating_icons",
    }).then((res) => {
      console.log(res);
      let list = res.data || [];

      if (list.length > 0) {
        this.floatingData = res.data[0];
        this.floatingStatic = true;
      }
    });
    // this.getbannerList();
    // this.getgoodsList();
    // this.getgoodBookList();
    if (this.$store.getters.token) {
      // this.getGuessFavourite(1);
    } else {
      // this.getGuessFavourite(0); //0=>未登录   1=>已登录
    }
    // this.gethomePageselHotBookList();
    // this.getselSubjectList();
    // this.getselAuthorList();
    // this.getselDeptList();
    clearInterval(this.setinter);
    this.setinter = setInterval(() => {
      this.goodsType++;
      if (this.goodsType === this.goodsTypeList.length) {
        this.goodsType = 0;
      }
      // this.gethomePageselHotBookList();
    }, 10000);
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      clearInterval(this.setinter);
      if (to.name === "首页") {
        this.setinter = setInterval(() => {
          this.goodsType++;
          if (this.goodsType === this.goodsTypeList.length) {
            this.goodsType = 0;
          }
          // this.gethomePageselHotBookList();
        }, 10000);
      }
    },
  },
  mounted() { },
  methods: {
    //首页置灰
    getConfig() {
      getConfigKey().then((res) => {
        this.UpTheme(res.data);
      });
    },
    UpTheme(data) {
      if (data == 0) {
        this.theme = true;
      } else {
        this.theme = false;
      }
    },
    // banner列表
    getbannerList() {
      bannerList({
        pageNum: 1,
        pageSize: 10,
      }).then((res) => {
        this.banner = res.data;
      });
    },
    bannerdetail(to) {
      //如果轮播图有对应的链接就去跳转
      if (to) {
        window.open(to, "_blank");
      }
    },
    todetail(id) {
      let routeUrl = this.$router.resolve({
        path: "/special/specialDetail",
        query: {
          subjectId: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    toauthorDetail(id) {
      let routeUrl = this.$router.resolve({
        path: "/authorLibrary/authorDetail",
        query: {
          authorId: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    tocoagencyDetail(id) {
      let routeUrl = this.$router.resolve({
        path: "/coagency/coagencyDetail",
        query: {
          deptId: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    tobookDetail(id, goodsType) {
      let url = "";
      if (goodsType == "train") {
        url = "/willingLearn/bookstoreDetail";
      } else {
        url = "/bookstore/bookstoreDetail";
      }
      let routeUrl = this.$router.resolve({
        path: url,
        query: {
          goodsId: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    //   handleClick(){
    //   console.log(1)
    // },
  },
};
</script>
<style scoped lang="scss">
@import url("../../assets/styles/certify.css");

.index_con {
  width: 100%;
}

.index_banner_box {
  width: 100%;
  min-width: 1400px;
  /* height: 540px; */
  position: relative;
  z-index: 0;
  overflow: hidden;
}

.recommend-module {
  position: relative;

  .floating-icons {
    position: fixed;
    top: 650px;
    left: 50%;
    z-index: 999;
    transform: translateX(650px);
    width: 100px;
    height: 100px;

    img {
      cursor: pointer;
      width: 100%;
    }

    .el-icon-close {
      position: absolute;
      top: 2px;
      right: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #e7e7e7;
      font-size: 12px;
      cursor: pointer;
      border-radius: 50%;
    }
  }
}

@media (min-width: 991px) and (max-width: 1600px) {
  .recommend-module {
    .floating-icons {
      top: 580px;
      left: 100%;
      transform: translateX(-110px);
    }
  }
}
</style>
